'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeName = changeName;
exports.changeMail = changeMail;
exports.changeMailWithCode = changeMailWithCode;
exports.changePhone = changePhone;
exports.changePhoneWithCode = changePhoneWithCode;
exports.confirmMail = confirmMail;
exports.confirmMailWithCode = confirmMailWithCode;
exports.confirmEMailBySignature = confirmEMailBySignature;
exports.confirmPhone = confirmPhone;
exports.confirmPhoneWithCode = confirmPhoneWithCode;
exports.resetError = resetError;
exports.changePassword = changePassword;
exports.changeInn = changeInn;
exports.changeUlName = changeUlName;
exports.addAddress = addAddress;

var _constants = require('redux/constants');

var _auth = require('redux/actions/auth');

var handleChange = function handleChange(result, dispatch) {
    console.log('handleChange', dispatch);
    if (!!result) {
        return dispatch((0, _auth.load)());
    }
    return !!result;
};

function changeName(pipo_id, name, new_name) {
    return {
        types: [_constants.UserConstants.USER_CHANGE, _constants.UserConstants.USER_CHANGE_SUCCESS, _constants.UserConstants.USER_CHANGE_FAIL],
        promise: function promise(client, iBonus, _ref) {
            var dispatch = _ref.dispatch;
            return iBonus.changeName(pipo_id, name, new_name).then(function (result) {
                return handleChange(result, dispatch);
            });
        }
    };
}

function changeMail(pipo_id, new_email, code, callBackShowModal) {
    return {
        types: [_constants.UserConstants.USER_CHANGE_MAIL, _constants.UserConstants.USER_CHANGE_MAIL_SUCCESS, _constants.UserConstants.USER_CHANGE_MAIL_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.changeMail(pipo_id, new_email, code).then(function (result) {
                callBackShowModal(result.code_send_to);
                return result;
            });
        }
    };
}

function changeMailWithCode(pipo_id, new_email, code) {
    return {
        types: [_constants.UserConstants.USER_CHANGE_MAIL_CODE, _constants.UserConstants.USER_CHANGE_MAIL_CODE_SUCCESS, _constants.UserConstants.USER_CHANGE_MAIL_CODE_FAIL],
        promise: function promise(client, iBonus, _ref2) {
            var dispatch = _ref2.dispatch;
            return iBonus.changeMailWithCode(pipo_id, new_email, code).then(function (result) {
                return handleChange(result, dispatch);
            });
        }
    };
}

function changePhone(pipo_id, new_phone, code, callBackShowModal) {
    return {
        types: [_constants.UserConstants.USER_CHANGE_PHONE, _constants.UserConstants.USER_CHANGE_PHONE_SUCCESS, _constants.UserConstants.USER_CHANGE_PHONE_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.changePhone(pipo_id, new_phone, code).then(function (result) {
                callBackShowModal();
                return result;
            });
        }
    };
}

function changePhoneWithCode(pipo_id, new_phone, code) {
    return {
        types: [_constants.UserConstants.USER_CHANGE_PHONE_CODE, _constants.UserConstants.USER_CHANGE_PHONE_CODE_SUCCESS, _constants.UserConstants.USER_CHANGE_PHONE_CODE_FAIL],
        promise: function promise(client, iBonus, _ref3) {
            var dispatch = _ref3.dispatch;
            return iBonus.changePhoneWithCode(pipo_id, new_phone, code).then(function (result) {
                return handleChange(result, dispatch);
            });
        }
    };
}

function confirmMail(pipo_id, email, code) {
    return {
        types: [_constants.UserConstants.USER_CONFIRM_MAIL, _constants.UserConstants.USER_CONFIRM_MAIL_SUCCESS, _constants.UserConstants.USER_CONFIRM_MAIL_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.confirmMail(pipo_id, email, code);
        }
    };
}

function confirmMailWithCode(pipo_id, email, code) {
    return {
        types: [_constants.UserConstants.USER_CONFIRM_MAIL_CODE, _constants.UserConstants.USER_CONFIRM_MAIL_CODE_SUCCESS, _constants.UserConstants.USER_CONFIRM_MAIL_CODE_FAIL],
        promise: function promise(client, iBonus, _ref4) {
            var dispatch = _ref4.dispatch;
            return iBonus.confirmMailWithCode(pipo_id, email, code).then(function (result) {
                return handleChange(result, dispatch);
            });
        }
    };
}

function confirmEMailBySignature(order_id, confirm_signature) {
    return {
        types: [_constants.UserConstants.USER_CONFIRM_MAIL_BY_SIGNATURE, _constants.UserConstants.USER_CONFIRM_MAIL_BY_SIGNATURE_SUCCESS, _constants.UserConstants.USER_CONFIRM_MAIL_BY_SIGNATURE_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.confirmEMailBySignature(order_id, confirm_signature);
        }
    };
}

function confirmPhone(pipo_id, phone, code) {
    return {
        types: [_constants.UserConstants.USER_CONFIRM_PHONE, _constants.UserConstants.USER_CONFIRM_PHONE_SUCCESS, _constants.UserConstants.USER_CONFIRM_PHONE_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.confirmPhone(pipo_id, phone, code);
        }
    };
}

function confirmPhoneWithCode(pipo_id, phone, code) {
    return {
        types: [_constants.UserConstants.USER_CONFIRM_PHONE_CODE, _constants.UserConstants.USER_CONFIRM_PHONE_CODE_SUCCESS, _constants.UserConstants.USER_CONFIRM_PHONE_CODE_FAIL],
        promise: function promise(client, iBonus, _ref5) {
            var dispatch = _ref5.dispatch;
            return iBonus.confirmPhoneWithCode(pipo_id, phone, code).then(function (result) {
                return handleChange(result, dispatch);
            });
        }
    };
}

function resetError() {
    return {
        type: _constants.UserConstants.USER_RESET_ERROR
    };
}

function changePassword(login, new_password, new_repassword, old_password) {
    return {
        types: [_constants.UserConstants.USER_CHANGE_PASSWORD, _constants.UserConstants.USER_CHANGE_PASSWORD_SUCCESS, _constants.UserConstants.USER_CHANGE_PASSWORD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.changePassword(login, new_password, new_repassword, old_password);
        }
    };
}

function changeInn(inn) {
    return {
        types: [_constants.UserConstants.USER_CHANGE_INN, _constants.UserConstants.USER_CHANGE_INN_SUCCESS, _constants.UserConstants.USER_CHANGE_INN_FAIL],
        promise: function promise(client, iBonus, _ref6) {
            var dispatch = _ref6.dispatch;
            return iBonus.updateInn(inn).then(function (result) {
                return handleChange(result, dispatch);
            });
        }
    };
}

function changeUlName(ul_name) {
    return {
        types: [_constants.UserConstants.USER_CHANGE_UL_NAME, _constants.UserConstants.USER_CHANGE_UL_NAME_SUCCESS, _constants.UserConstants.USER_CHANGE_UL_NAME_FAIL],
        promise: function promise(client, iBonus, _ref7) {
            var dispatch = _ref7.dispatch;
            return iBonus.updateUlName(ul_name).then(function (result) {
                return handleChange(result, dispatch);
            });
        }
    };
}

function addAddress(address) {
    return {
        types: [_constants.UserConstants.USER_ADD_ADDRESS, _constants.UserConstants.USER_ADD_ADDRESS_SUCCESS, _constants.UserConstants.USER_ADD_ADDRESS_FAIL],
        promise: function promise(client, iBonus, _ref8) {
            var dispatch = _ref8.dispatch;
            return iBonus.addAddress(address).then(function (result) {
                return handleChange(result, dispatch);
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/user.js
// module id = 115
// module chunks = 0